<script setup lang="ts">
/**
 * A line of the Copilote: the avatar and the bubble that speaks in a scene.
 *
 * The scene passes the words it was served — the handler of its bloc composes
 * and freezes them, never the front. While a scene waits on something,
 * `typing` renders the same bubble as the three-dot indicator instead of
 * words.
 */
defineProps<{text?: string; typing?: boolean}>();
</script>

<template>
  <div class="flex gap-2.5 items-start">
    <span
      class="w-[30px] h-[30px] mt-0.5 shrink-0 rounded-full flex items-center justify-center
             bg-gradient-to-r from-primary-dark to-primary"
    >
      <img src="@/assets/images/logos/apodis-white.svg" alt="Copilote" class="h-[15px]">
    </span>

    <div
      class="max-w-[75%] bg-white border border-slate-200 px-4 py-2.5 text-sm leading-relaxed
             rounded-r-2xl rounded-bl-2xl rounded-tl shadow-sm"
    >
      <span v-if="typing" class="inline-flex items-center gap-1 h-[19px]">
        <span
          v-for="delay in ['0s', '0.2s', '0.4s']"
          :key="delay"
          class="w-1.5 h-1.5 rounded-full bg-primary animate-dot-pulse"
          :style="{animationDelay: delay}"
        />
      </span>
      <template v-else>
        {{ text }}
      </template>
    </div>
  </div>
</template>
